import { lessonsInOrder, type Bundle } from "@otto/lehrgang";
import type { StudentRow } from "../lib/data.js";
import { starsForLesson } from "../lib/lessonStars.js";
import own from "./ResultsTable.module.css";

/**
 * Die Matrix EINES Lehrgangs: eine Zeile je Code, eine Spalte je Lektion.
 *
 * Sie beantwortet die andere Frage – „hakt Lektion 4 bei allen?“ –, und deshalb
 * gibt es sie noch. Sie ist aber nicht mehr die Hauptansicht: die stand hier
 * einmal je Lehrgang untereinander, und ein Kind kam dann sechsmal auf der Seite
 * vor. „Zuletzt geübt“ ist mit umgezogen; es hängt am Kind und nicht am
 * Lehrgang, stand hier aber in jeder der Tabellen noch einmal.
 */
export function ResultsTable({
  bundle,
  rows,
}: {
  bundle: Bundle;
  rows: readonly StudentRow[];
}) {
  const lessons = lessonsInOrder(bundle);

  return (
    <div className={own.wrap}>
      <table>
        <thead>
          <tr>
            <th scope="col">Übungscode</th>
            {lessons.map((lesson) => (
              <th
                key={lesson.key}
                scope="col"
                title={`${lesson.title} · ${lesson.subtitle}`}
              >
                {lesson.number}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.map((row) => (
            <tr key={row.code}>
              <td className={own.code}>{row.code}</td>
              {lessons.map((lesson) => {
                const mark = starsForLesson(lesson, row, bundle.starThresholds);
                return (
                  <td key={lesson.key} className={own.cell}>
                    {mark === null ? (
                      <span className={own.none}>–</span>
                    ) : (
                      <span
                        className={mark.complete ? own.stars : own.starsPartial}
                        title={
                          mark.complete
                            ? "alle Stufen geübt"
                            : "Lektion begonnen, noch nicht alle Stufen geübt"
                        }
                      >
                        {"★".repeat(mark.stars ?? 0)}
                      </span>
                    )}
                  </td>
                );
              })}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
